<template>
  <!-- ────── HEADER ────── -->
  <header class="bg-card/80 backdrop-blur-md border-b border-border/50 sticky top-0 z-50" dir="rtl">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-14 md:h-16 w-full">

        <!-- LOGO -->
        <router-link to="/" class="flex items-center gap-2 group">
          <div class="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm">
            <img src="@/assets/logo-sazibaz.png" class="w-4/5" alt="لوگو شاپیکام" />
          </div>
          <span class="text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
            شاپیکام
          </span>
        </router-link>

        <!-- دکمهٔ همبرگر (موبایل) - اگه خواستی Drawer رو حذف کنی، این دکمه رو پاک کن -->
        <button @click="toggleDrawer"
          class="md:hidden flex items-center justify-center p-2 rounded-md hover:bg-muted transition-colors"
          aria-label="منوی موبایل">
          <svg class="w-6 h-6 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <!-- منوی دسکتاپ -->
        <nav class="hidden md:flex items-center gap-6 text-sm">
          <router-link to="/" class="text-muted-foreground hover:text-foreground transition-colors"
            active-class="text-primary" exact>خانه</router-link>

          <router-link to="/features" class="text-muted-foreground hover:text-foreground transition-colors"
            active-class="text-primary">ویژگی‌ها</router-link>

          <router-link to="/plane" class="text-muted-foreground hover:text-foreground transition-colors"
            active-class="text-primary">قیمت‌گذاری</router-link>

          <router-link to="/about" class="text-muted-foreground hover:text-foreground transition-colors"
            active-class="text-primary">درباره ما</router-link>

          <router-link to="/blog" class="text-muted-foreground hover:text-foreground transition-colors"
            active-class="text-primary">وبلاگ</router-link>
        </nav>

        <!-- دکمه «شروع رایگان» (دسکتاپ) -->
        <a href="https://panel.shopecom.ir/"
          class="hidden md:inline-flex bg-primary hover:bg-primary/90 text-primary-foreground px-4 py-1.5 rounded-md text-sm font-medium transition-colors"
          style="background: linear-gradient(135deg, #eb4763, #a347d1);">شروع رایگان</a>
      </div>
    </div>

    <!-- ────── DRAWER (موبایل) ────── -->
    <!-- اگه نمی‌خوای از Drawer استفاده کنی (چون نویگیشن پایین داری)، این بخش رو می‌تونی پاک کنی -->
    <!-- پس‌زمینهٔ تیره -->
    <transition name="fade">
      <div v-if="isDrawerOpen" class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40" @click="closeDrawer"></div>
    </transition>

    <!-- منوی کشویی که از سمت راست می‌آید -->
    <transition name="slide-right">
      <aside v-if="isDrawerOpen"
        class="fixed top-0 right-0 h-[100dvh] bg-white shadow-2xl z-50 overflow-y-auto p-6 " style="    width: 70%;">
        <!-- دکمه بستن -->
        <button @click="closeDrawer" class="flex items-center mb-6 text-muted-foreground hover:text-foreground"
          aria-label="بستن منو">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span class="mr-2">بستن</span>
        </button>

        <!-- لیست لینک‌ها با استفاده از کامپوننت MenuItem -->
        <nav class="flex flex-col space-y-2 text-sm">
          <MenuItem to="/" icon="M3 12l2-2m0 0L12 3l7 7m-9 9v-6h4v6m-4 0h6a2 2 0 002-2v-8l-8-8-8 8v8a2 2 0 002 2h6z"
            label="خانه" @click="closeDrawer" exact />
          <MenuItem to="/features" icon="M12 6v6l4 2M12 6a9 9 0 110 18 9 9 0 010-18z" label="ویژگی‌ها"
            @click="closeDrawer" />
          <MenuItem to="/plane" icon="M12 8c-3.86 0-7 1.79-7 4s3.14 4 7 4 7-1.79 7-4-3.14-4-7-4zM5 12h14"
            label="قیمت‌گذاری" @click="closeDrawer" />
          <MenuItem to="/about" icon="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 110 20 10 10 0 010-20z" label="درباره ما"
            @click="closeDrawer" />
          <MenuItem to="/blog"
            icon="M12 8h.01M12 12h.01M12 16h.01M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z"
            label="وبلاگ" @click="closeDrawer" />
        </nav>

        <!-- دکمه «شروع رایگان» داخل Drawer -->
        <a href="https://panel.shopecom.ir/"
          class="mt-8 flex items-center justify-center space-x-2 px-4 py-2 rounded-md bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-medium transition-colors"
          style="background: linear-gradient(135deg, #eb4763, #a347d1);" @click="closeDrawer">
          <svg class="w-4 h-4 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          <span>شروع رایگان</span>
        </a>
      </aside>
    </transition>
  </header>

  <!-- ────── BOTTOM NAVIGATION (موبایل) ────── -->
  <nav
    class="md:hidden fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-lg border-t border-border/50 z-40 pb-safe"
    dir="rtl">
    <div class="flex items-center justify-around h-16">

      <!-- خانه -->
      <router-link to="/"
        class="flex flex-col items-center justify-center w-full h-full space-y-1 text-muted-foreground hover:text-primary transition-colors"
        active-class="text-primary">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 12l2-2m0 0L12 3l7 7m-9 9v-6h4v6m-4 0h6a2 2 0 002-2v-8l-8-8-8 8v8a2 2 0 002 2h6z" />
        </svg>
        <span class="text-xs font-medium">خانه</span>
      </router-link>

      <!-- ویژگی‌ها -->
      <router-link to="/features"
        class="flex flex-col items-center justify-center w-full h-full space-y-1 text-muted-foreground hover:text-primary transition-colors"
        active-class="text-primary">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <span class="text-xs font-medium">ویژگی‌ها</span>
      </router-link>

      <!-- دکمه شروع رایگان (شناور در وسط) -->
      <a href="https://panel.shopecom.ir/" class="flex flex-col items-center justify-center -mt-6 relative">
        <div class="w-12 h-12 rounded-full flex items-center justify-center text-white shadow-lg shadow-primary/30 
                    active:scale-95 transition-transform"
          style="background: linear-gradient(135deg, #eb4763, #a347d1);">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <span class="text-[10px] text-muted-foreground mt-1 font-medium">شروع</span>
      </a>

      <!-- وبلاگ -->
      <router-link to="/blog"
        class="flex flex-col items-center justify-center w-full h-full space-y-1 text-muted-foreground hover:text-primary transition-colors"
        active-class="text-primary">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
        </svg>
        <span class="text-xs font-medium">وبلاگ</span>
      </router-link>

      <!-- درباره ما -->
      <router-link to="/about"
        class="flex flex-col items-center justify-center w-full h-full space-y-1 text-muted-foreground hover:text-primary transition-colors"
        active-class="text-primary">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span class="text-xs font-medium">درباره ما</span>
      </router-link>

    </div>
  </nav>
</template>

<script>
export default { name: 'AppHeader' }
</script>

<script setup>
import { ref } from 'vue'
import MenuItem from './MenuItem.vue'   // ← اطمینان حاصل کنید مسیر درست باشد

const isDrawerOpen = ref(false)

function toggleDrawer() {
  isDrawerOpen.value = !isDrawerOpen.value
}
function closeDrawer() {
  isDrawerOpen.value = false
}
</script>

<style scoped>
/* fade برای پس‌زمینهٔ تاریک */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* slide‑right برای Drawer */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Safe Area برای آیفون */
.pb-safe {
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
